(() => {
  const mobile=matchMedia('(max-width:768px)');
  const sections=new WeakMap();
  function attach(section) {
    if(sections.has(section)){sections.get(section).update();return;}
    if(section.dataset.modal==='true')return;
    const block=section.querySelector('[id*="back_in_stock_restock_alert"]');
    const selector=section.querySelector('[data-product-select]');
    if(!block||!selector||section.querySelector('[data-quotify]'))return;
    let variants;
    try { variants=JSON.parse(section.querySelector('[data-variant-json]')?.value||'[]'); } catch {return;}
    if(!variants.length)return;
    const state={variantId:'',settledAt:0,pending:0};
    const update=()=>{
      const current=variants.find(v=>String(v.id)===selector.value);
      const root=block.querySelector('#zooomybackinstock');
      const email=root?.querySelector('#zooomyalertemail');
      const button=root?.querySelector('#zooomyalertbtn');
      if(state.variantId!==selector.value){state.variantId=selector.value;state.settledAt=performance.now()+650;clearTimeout(state.pending);button?.removeAttribute('aria-busy');}
      const active=current && !current.available && email && button && root.style.display!=='none';
      section.classList.toggle('md-waitlist-active',Boolean(active));
      section.classList.toggle('md-waitlist-available',Boolean(current?.available));
      if(email&&!email.hasAttribute('aria-label')){
        email.setAttribute('aria-label',email.placeholder||email.name);
        email.setAttribute('autocomplete','email');
        email.setAttribute('inputmode','email');
      }
      if(button && button.textContent.trim().toLowerCase()==='submit')button.textContent='Join waitlist';
      if(button&&!button.hasAttribute('role')){
        button.setAttribute('role','button');button.tabIndex=0;
        button.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();button.click();}});
      }
      root?.querySelectorAll('.zooomystockmsg').forEach(message=>{message.setAttribute('role','status');});
    };
    block.addEventListener('click',event=>{
      const button=event.target.closest('#zooomyalertbtn');
      if(!button)return;
      const current=variants.find(v=>String(v.id)===selector.value);
      if(!current||current.available){event.preventDefault();event.stopImmediatePropagation();return;}
      const remaining=state.settledAt-performance.now();
      if(remaining>0){
        event.preventDefault();event.stopImmediatePropagation();clearTimeout(state.pending);
        const selected=selector.value;
        button.setAttribute('aria-busy','true');
        state.pending=setTimeout(()=>{button.removeAttribute('aria-busy');if(selector.value===selected&&button.isConnected)button.click();},remaining+30);
      }
    },true);
    selector.addEventListener('change',()=>queueMicrotask(update));
    new MutationObserver(update).observe(block,{childList:true,subtree:true,attributes:true,attributeFilter:['style']});
    mobile.addEventListener('change',update);
    state.update=update;
    sections.set(section,state);
    update();
  }
  const refresh=()=>document.querySelectorAll('.product-section').forEach(attach);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
  document.addEventListener('shopify:section:load',refresh);
  window.addEventListener('pageshow',refresh);
})();
